import StreamApi from './StreamApi';
export default StreamApi;
